module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    staticClass: "card-category",
    style: (("background-color:" + (_vm.globalColors.border)))
  }, [_c('div', {
    staticClass: "card-name",
    style: (("background-color:" + (_vm.globalColors.primary)))
  }, [_c('img', {
    attrs: {
      "src": _vm.category.mobileImage,
      "alt": ""
    }
  }), _vm._v(" " + _vm._s(_vm.category.title) + "\n\t")]), _vm._v(" "), _c('div', {
    staticClass: "card-products"
  }, [_vm._l((_vm.products), function(product) {
    return [_c('product-card', {
      key: product.id,
      attrs: {
        "product": product
      }
    })]
  }), _vm._v(" "), _c('div', {
    staticClass: "card-btn"
  }, [_c('div', {
    staticClass: "btn-link",
    on: {
      "click": _vm.categoryRoute
    }
  }, [_vm._v("Ver más")])])], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0ab9a12c","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/products-by-category.vue
// module id = 1070
// module chunks = 46